import { render, staticRenderFns } from "./ManagePurchases.vue?vue&type=template&id=0b45a91e&scoped=true&"
import script from "./ManagePurchases.vue?vue&type=script&lang=js&"
export * from "./ManagePurchases.vue?vue&type=script&lang=js&"
import style0 from "./ManagePurchases.vue?vue&type=style&index=0&id=0b45a91e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b45a91e",
  null
  
)

export default component.exports